import on from '../util/elements/on'
import destroys from '../util/elements/destroys'
import Pen from '../util/elements/pen'
// import { reactive } from 'sitekit-extensions'
import { distanceFromPoints, pageCoordFromEvent } from '../util/math/graphing'
import anime from 'animejs'

const textaColour = '#CCDBF2'

export default function (Site, $) {
  Site.widget('page-draw', {
    create () {
      destroys(this)

      // Called from transitionIn
      this.init = true

      const siteWrapper = $('#site-wrapper')

      this.pen = new Pen(siteWrapper)

      const previous = $('.base-draw')
      if (previous.length) {
        previous.remove()
      }
      this.$pen = this.pen.$canvas
      this.$pen.addClass('base-draw')

      window.draw = this

      this.currentLine = []
      this.previous = false
      this.ignoreNext = false

      const $win = $(window)

      const ignores = on($('[data-nodraw]'), 'mousedown', e => {
        this.ignoreNext = true
      })

      const backKeys = on($win, 'keypress', e => {
        if (e.ctrlKey && e.which === 26) {
          if (e.shiftKey) {
            console.log('PEN: Going forwards')
            this.pen.restoreFuture()
          } else {
            console.log('PEN: Going back')
            this.pen.restoreLast()
          }
        }
      })

      const start = on(siteWrapper, 'mousedown', e => {
        // Don't draw on blacklist items
        if (this.ignoreNext) {
          this.ignoreNext = false
          return
        }

        this.target = e.target

        this.startTime = new Date().getTime()
        this.startPos = pageCoordFromEvent(e)
        this.previous = this.startPos
        $()
      })

      const end = on($win, 'mouseup', e => {
        if (this.hasStarted) this.pen.addRestore()

        this.startPos = false
        this.currentLine = []
        this.hasStarted = false
        this.startTime = false
        this.previous = false

        siteWrapper.removeClass('no-select')
      })

      const move = on(siteWrapper, 'mousemove', e => {
        if (!this.startPos) return

        this.currentPos = pageCoordFromEvent(e)

        const now = new Date().getTime()

        const distanceFromStart = distanceFromPoints(
          this.currentPos,
          this.startPos
        )

        this.currentLine.push(this.currentPos)

        if (
          (distanceFromStart > 3 && now - this.startTime < 600) ||
          this.hasStarted
        ) {
          this.hasStarted = true
          e.preventDefault()
          siteWrapper.addClass('no-select')
        }

        if (this.hasStarted) {
          this.pen.queue(pen => {
            this.pen.ctx.globalCompositeOperation = 'multiply'

            if (!this.previous) return

            const points = this.currentLine

            let point = points.shift()

            while (point) {
              pen.fillBetween({
                from: this.previous,
                to: point,
                size: 20,
                fill: textaColour
              })

              this.previous = point
              point = points.shift()
            }

            this.previous = this.currentPos
          })

          this.pen.render()
        }
      })

      const resize = on($win, 'resize', e => this.resize())

      this.destroys(
        start,
        move,
        end,
        resize,
        this.pen.destroy,
        ignores,
        backKeys
      )
    },
    resize () {
      this.pen.resize()
      this.pen.clear()
    },
    _transitionIn () {
      if ($(window).width() < 700) {
        this.init = false
        return
      }

      setTimeout(() => {
        this.create()
        this.resize()
      }, 300)
    },
    async _transitionOut () {
      if (!this.init) return

      await anime({
        targets: this.$pen.get(),
        opacity: 0,
        duration: 300,
        easing: 'easeOutQuad'
      }).finished

      this.pen.destroy()
    },
    undo () {
      this.pen.undo()
    }
  })
}
